import { operatorApiFetch } from './apiService';

export const inventoryTypeService = {
  // 主檔列表（lazyLoad 下拉選項用，回傳 { success, data: [{ id, code, name, full_name }] }）
  fetchList: async () => {
    const response = await operatorApiFetch('inventory_types', {
      method: 'GET'
    });
    return response.json();
  },

  // 列表
  getRecords: async (params) => {
    const response = await operatorApiFetch('inventory_types/get_records', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },

  // 全選 ID
  getIds: async (params) => {
    const response = await operatorApiFetch('inventory_types/get_ids', {
      method: 'POST',
      body: JSON.stringify(params)
    });
    return response.json();
  },

  // 取得所有 (不分頁)
  listAll: async () => {
    const response = await operatorApiFetch('inventory_types/list_all', {
      method: 'GET'
    });
    return response.json();
  },

  // 建立庫存類型
  create: async (data) => {
    const response = await operatorApiFetch('inventory_types', {
      method: 'POST',
      body: JSON.stringify({ inventory_type: data })
    });
    return response.json();
  }
};
